module.exports = {
      id: "arrow-usage",
      viewBox: "0 0 8.063 11.15",
      url: "/" + "sprite-d3510a915c790cce9510dd41eb326371.svg#arrow",
      toString: function () {
        return this.url;
      }
    }